import React, { useState, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { Container, CircularProgress, Typography } from '@mui/material';

const ProtectedApp = () => {
  const { linkId } = useParams();
  const [validationStatus, setValidationStatus] = useState(null); // null = carregando, 'valid' ou 'error'
  const [errorMsg, setErrorMsg] = useState('');

  useEffect(() => {
    const validateLink = async () => {
      try {
        const response = await fetch('https://approve.mydeapi.com', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-api-key': 'JZ5QplfUbSMXFd2wbsss6F3M9feB4Gi7zWWhVRN4' },
          body: JSON.stringify({
            action: 'ABRIR_LINK',
            payload: { id: linkId },
          }),
        });

        if (response.status === 200) {
          setValidationStatus('valid');
        } else if (response.status === 403) {
          setValidationStatus('error');
          setErrorMsg('Este link já foi utilizado.');
        } else if (response.status === 404) {
          setValidationStatus('error');
          setErrorMsg('Link não encontrado.');
        } else {
          setValidationStatus('error');
          setErrorMsg('Erro desconhecido.');
        }
      } catch (error) {
        setValidationStatus('error');
        setErrorMsg('Erro na conexão.');
      }
    };

    validateLink();
  }, [linkId]);

  if (validationStatus === null) {
    return (
      <Container style={{ marginTop: '20px', textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (validationStatus === 'error') {
    return (
      <Container style={{ marginTop: '20px', textAlign: 'center' }}>
        <Typography variant="h5" color="error">
          {errorMsg}
        </Typography>
      </Container>
    );
  }

  return <Outlet />;
};

export default ProtectedApp;
